import _ from 'lodash';
import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';
import Echo from 'laravel-echo';
import io from 'socket.io-client';

window._ = _;

// jQuery is used globally by the inline scripts in the Blade views
window.$ = window.jQuery = $;

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// broadcasting via laravel-echo-server (socket.io)
window.io = io;
window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: process.env.ECHO_SERVER_URL,
});
